import { render } from "./AddAuctions.vue?vue&type=template&id=60acebf0"
import script from "./AddAuctions.vue?vue&type=script&lang=js"
export * from "./AddAuctions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__